import { useEffect, useRef } from 'react';
import { api } from '../api';

/**
 * Background Poseidon monitor — pings system health every 60s.
 * Runs silently, no UI. Poseidon uses these heartbeats to track
 * client portal activity and system health.
 */
export function usePoseidonMonitor() {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    // Initial ping
    api.get('/system/health').catch(() => {});

    // Heartbeat every 60 seconds
    intervalRef.current = setInterval(() => {
      api.get('/system/health').catch(() => {});
    }, 60_000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);
}

export default usePoseidonMonitor;
